<h2 *ngIf="title" class="title-5 mb-4">
  {{ title }}
</h2>

<ul *ngIf="actions?.length">
  <li
    *ngFor="let action of actions"
    class="flex items-center mb-2 font-condensed font-bold"
  >
    <ng-container [ngTemplateOutlet]="action.itemTemplate"></ng-container>
  </li>
</ul>
